import React from "react";
import { CACHE_PAIRING_TYPE } from "src/constants/actionCache";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { useState } from "react";
import ShowCachePairingType from "../ShowCache/ShowCachePairingType";
import FLFPairingTypePopup from "../Popup/FLFPairingTypePopup";

const FLFPairingTypeControlPanel = ({
  children,
  currentActionCache,
  recordForEdit,
  openPopup,
  setOpenPopup,
  handleOpenPopup,
  addOrEdit,
  errorsForm,
}) => {
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <DeployCache
          title="Cache PairingType"
          isShowButton={isShowCache(currentActionCache, CACHE_PAIRING_TYPE)}
        >
          <ShowCachePairingType
            disableButton={disableButton}
            setDisableButton={setDisableButton}
          />
        </DeployCache>

        <FLFPairingTypePopup
          recordForEdit={recordForEdit}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          handleOpenPopup={handleOpenPopup}
          addOrEdit={addOrEdit}
          errorsForm={errorsForm}
        />
      </div>
    </div>
  );
};

export default FLFPairingTypeControlPanel;
